<template>
  <v-container
    v-if="role && permissions"
    :style="{width: '100%', maxWidth: '960px'}"
    ref="parent"
    fluid
  >

    <v-card outlined class="ma-2" style="margin-bottom: 58px !important;">
      <v-card-title>Rol</v-card-title>

      <v-divider class="mx-4"/>

      <v-card-text>
        <v-row no-gutters>

          <v-col cols="12">
            <v-text-field v-model="role.name" label="Nume" class="ma-1" hide-details outlined dense/>
          </v-col>
          <v-col cols="12">
            <v-textarea v-model="role.description" label="Descriere" class="ma-1" hide-details outlined dense/>
          </v-col>
          <v-col cols="12">
            <v-autocomplete v-model="role.permissions" :items="permissions" class="ma-1" label="Permisiuni" multiple outlined dense hide-details>
              <template v-slot:selection="data">
                <v-chip v-bind="data.attrs" :input-value="data.selected" @click:close="onPermissionRemoved(data.item)" close small>
                  {{data.item.text}}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>

        </v-row>
      </v-card-text>

    </v-card>

    <v-card outlined v-resize="onResize" :width="dynamic_width" class="ma-2" :style="{position: 'fixed', bottom: 0, maxWidth: '960px'}">
      <v-card-actions>
        <v-btn v-if="role.id" depressed color="delete white--text" @click="destroy" :loading="deleting" :disabled="deleting">
          <v-icon left>mdi-delete</v-icon>
          Șterge
        </v-btn>
        <v-spacer/>
        <v-btn depressed color="primary white--text" @click="save" :loading="saving" :disabled="saving">
          <v-icon left>mdi-floppy</v-icon>
          Salvează
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>
</template>

<script>

  import roles_repository from '@/repositories/roles-repository';
  import config_repository from '@/repositories/config-repository';

  export default {

    data: () => ({
      role: null,
      permissions: null,

      saving: false,
      deleting: false,

      dynamic_width: 0
    }),

    created() {
      roles_repository.getRole(this.$route.params.role).then(r => this.role = r);
      config_repository.getPermissions().then(r => this.permissions = r);
    },

    methods: {
      async save() {
        try {
          this.saving = true;
          this.role = await roles_repository.saveRole(this.role);
          await this.$store.dispatch('alert/success', 'Rolul a fost salvat.');

          if (this.$route.params.role === 'create')
            await this.$router.push(`/admin/roles/${this.role.id}`);

          this.role = await roles_repository.getRole(this.role.id);
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.saving = false;
        }
      },

      async destroy() {
        try {
          this.deleting = true;
          await roles_repository.destroyRole(this.role);
          await this.$router.push(`/admin/roles`);
          await this.$store.dispatch('alert/success', 'Rolul a fost ștears.');
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.deleting = false;
        }
      },

      onPermissionRemoved(permission) {
        const index = this.role.permissions.indexOf(permission.value);
        if (index >= 0) this.role.permissions.splice(index, 1)
      },

      onResize() {
        this.dynamic_width = this.$refs['parent'].clientWidth - 40;
      }
    }

  }
</script>